import { THEMES, themeCssPath } from '../../../shared/themes.js'

const themes = THEMES.map(theme => ({
  id: theme.id,
  name: theme.name,
  css: themeCssPath(theme.id)
}))

export default themes
